// src/components/charts/InvertidoVsEbitdaChart.jsx
import React, { useState, useEffect } from 'react';
import { Card, Alert, Spinner, Row, Col } from 'react-bootstrap';
import LineChart from '../agComponents/LineChart';
import kpiService from '../../services/kpiService';
import { formatCurrency } from '../../utils/formatters';

/**
 * Componente que muestra Total Invertido vs Total Ebitda
 * Incluye gráfico de líneas y distribución de inversiones
 */
const InvertidoVsEbitdaChart = ({ fechaInicio, fechaFin, empresaId }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getInvertidoVsEbitda({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success) {
          setChartData(response.data);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching invertido vs ebitda:', err);
        setError('Error al cargar el gráfico.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (error) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="danger">{error}</Alert>
        </Card.Body>
      </Card>
    );
  }

  if (loading) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Cargando datos...</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Body>
        <h5 className="mb-3">Total Invertido vs Total Ebitda acumulado por línea de negocio</h5>
        
        <div className="mb-3">
          <small className="text-muted">Evolución de las inversiones</small>
        </div>

        <LineChart
          data={chartData.data}
          xKey="month"
          series={chartData.series}
          height={280}
        />

        {/* Distribución de Inversiones */}
        {chartData.distribucion && (
          <div className="mt-4 pt-3 border-top">
            <h6 className="mb-3">Distribución de inversiones</h6>
            <Row className="g-3">
              {chartData.distribucion.map((item, idx) => (
                <Col key={idx} xs={4} className="text-center">
                  <div
                    className="rounded p-2 mb-2"
                    style={{
                      backgroundColor: item.color,
                      opacity: 0.1,
                    }}
                  >
                    <div
                      className="fw-bold"
                      style={{ color: item.color }}
                    >
                      {formatCurrency(item.valor)}
                    </div>
                  </div>
                  <small className="text-muted">{item.linea}</small>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default InvertidoVsEbitdaChart;